import React, { memo, useCallback, useState } from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import styled from 'styled-components'

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis)

const TextReadMoreComponent = ({ children }: TextReadMoreProps): JSX.Element | null => {
	const [isShown, setIsShown] = useState(false)
	const [isClamped, setIsClamped] = useState(false)
	const handleReflow = useCallback(({ clamped }: { clamped: boolean }) => setIsClamped(clamped), [])
	if (!children) {
		return null
	}

	if (isShown) {
		return <div>{children}</div>
	}

	return (
		<>
			<ResponsiveEllipsis text={children} onReflow={handleReflow} maxLine={5} />
			{isClamped && (
				<Button type='button' onClick={() => setIsShown(true)}>
					Показать полностью
				</Button>
			)}
		</>
	)
}

const Button = styled.button(({ theme }) => ({
	backgroundColor: 'transparent',
	cursor: 'pointer',
	color: theme.colors.main,
	'&:hover': {
		color: theme.colors.buttonhover,
	},
	'&:active': {
		color: theme.colors.buttonpressed,
	},
	display: 'block',
	width: '100%',
	textAlign: 'left',
	paddingTop: 20,
	...theme.typography.text16_22,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text18_24,
	},
	[theme.mediaQueries.mediaMinWidthTablet]: {
		textAlign: 'center',
		paddingTop: 48,
		...theme.typography.text20_28,
	},
	[theme.mediaQueries.mediaMinWidthDesktop]: {
		paddingTop: 20,
	},
}))

interface TextReadMoreProps {
	children?: string | undefined
}

export const TextReadMore = memo(TextReadMoreComponent)
